import {Support, SupportRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {useParams} from "react-router-dom";
import {dateToString} from "../../../../components/utils/dates";
import {parsePathId} from "../../../../components/form/form_utils";
import {ScoreBadge} from "../../employee/evaluation/ui";

export const SupportListPage = () => {
	const apiManager = useApiManager();
	const params = useParams();
	const personId = parsePathId(params, "personId");

	const listConfig: AppListConfig<Support> = {
		title: "Valoraciones de clientes",
		onClick: personId
			? "/app/admin/employee/person/" + personId + "/support"
			: "/app/admin/compliance/support",
		headers: [
			{title: "Fecha"},
			{title: "Persona"},
			{title: "Puntuación"},
			{title: "Evaluador"},
		],
		decorator: (bean: Support) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "inherit"}}>
					{dateToString(bean.evaluationDate)}
				</TableCell>
				<TableCell>
					{bean.person.name + " " + bean.person.surnames}
				</TableCell>
				<TableCell>
					{/* Las respuestas de valoración van de 0 a 50 («Excelente»); ScoreBadge espera la escala de 0 a 40
					    de las autoevaluaciones, así que se reescala para enseñarla sobre 10. */}
					{bean.rating !== undefined && bean.rating !== null ? <ScoreBadge rating={bean.rating * 40 / 50}/> : "—"}
				</TableCell>
				<TableCell>
					{bean.evaluator}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(SupportRestControllerApiFactory);
			return ctrl.pageSupport(currentPage, size, undefined, personId,
				undefined, undefined, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};